import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
import { toast } from 'react-toastify';
import ApiBaseURL from '../ApiBaseUrl/ApiBaseURL';
import { useNavigate } from 'react-router-dom';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DashboardActiveVehicleTypeDetails = ({
    vehicleTypeId = null,
    vendorId = null,
    driverId = null,
    vehicleId = null,
    period = null
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedRange, setSelectedRange] = useState(period);
    const [vehicleData, setVehicleData] = useState([]);
    const [vehicleStats, setVehicleStats] = useState(null);

    const filterOptions = ['Today', 'Yesterday', 'Week', '1M', '3M', '6M'];

    const navigate = useNavigate();

    const handleFilterSelect = (range) => {
        setSelectedRange(range);
        setShowDropdown(false);
    };

    // const handleGetActiveVehicles = async () => {
    //     const userId = localStorage.getItem('userId');
    //     const token = localStorage.getItem('token');

    //     if (!userId || !token) {
    //         toast.error('Missing userId or token');
    //         return;
    //     }

    //     try {
    //         const resp = await fetch(`${ApiBaseURL}/get/active-vehicles-by-type`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 userId,
    //                 Authorization: `Bearer ${token}`
    //             },
    //             body: JSON.stringify({
    //                 vehicleTypeId,
    //                 vendorId,
    //                 driverId,
    //                 vehicleId,
    //                 // period: selectedRange
    //                 period
    //             })
    //         });

    //         const result = await resp.json();

    //         if (resp.ok && result.statusDescription.statusCode === 200) {
    //             setVehicleData(result.data || []);
    //         } else {
    //             toast.error(result.statusDescription.description || 'Failed to fetch vehicle data');
    //         }
    //     } catch (error) {
    //         toast.error('Error fetching active vehicle data: ' + error.message);
    //     }
    // };

    const handleGetActiveVehicles = async () => {
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');

        if (!userId || !token) {
            toast.error('Missing userId or token');
            return;
        }

        try {
            const resp = await fetch(`${ApiBaseURL}/dashboard/v1/get/active-vehicles-by-type`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    userId,
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    vehicleTypeId,
                    vendorId,
                    driverId,
                    vehicleId,
                    // period: selectedRange
                    period
                })
            });

            const result = await resp.json();

            if (resp.ok && result.statusDescription.statusCode === 200) {
                if (Array.isArray(result.data) && result.data.length > 0) {
                    setVehicleStats(result.data[0]);
                } else {
                    setVehicleStats(null);
                    toast.warn('No data available');
                }
            } else if ([401, 403].includes(result.statusDescription.statusCode)) {
                toast.error(result.statusDescription.description || "Unauthorized access. Redirecting...");
                localStorage.clear();

                setTimeout(() => {
                    window.location.replace('/');
                }, 1500);
            } else {
                console.log(result.statusDescription.description || 'Failed to fetch vehicle data');
            }
        } catch (error) {
            toast.error('Error fetching active vehicle data: ' + error.message);
        }
    };

    useEffect(() => {
        handleGetActiveVehicles();
    }, [vehicleTypeId, vendorId, driverId, vehicleId, selectedRange, period]);

    const labels = vehicleData.map(item => item.vehicleType || 'Unknown');
    const values = vehicleData.map(item => item.activeCount || 0);

    // const chartData = {
    //     labels,
    //     datasets: [
    //         {
    //             label: 'Active Vehicles',
    //             data: values,
    //             backgroundColor: [
    //                 'rgba(54, 162, 235, 0.7)',
    //                 'rgba(255, 206, 86, 0.7)',
    //                 'rgba(75, 192, 192, 0.7)',
    //                 'rgba(153, 102, 255, 0.7)',
    //                 'rgba(255, 159, 64, 0.7)'
    //             ],
    //             borderColor: [
    //                 'rgba(54, 162, 235, 1)',
    //                 'rgba(255, 206, 86, 1)',
    //                 'rgba(75, 192, 192, 1)',
    //                 'rgba(153, 102, 255, 1)',
    //                 'rgba(255, 159, 64, 1)'
    //             ],
    //             borderWidth: 1,
    //         }
    //     ]
    // };

    const chartData = {
        labels: ['Active Vehicles', 'Inactive Vehicles'],
        datasets: [
            {
                label: 'Vehicle Stats',
                // data: vehicleStats
                //     ? [parseInt(vehicleStats.shift), parseInt(vehicleStats.softTripCount)]
                //     : [0, 0],
                data: vehicleStats
                    ? [
                        Math.round(vehicleStats.shift ?? 0),
                        Math.round(vehicleStats.softTripCount ?? 0)
                    ]
                    : [0, 0],
                backgroundColor: [
                    'rgba(75, 192, 192, 0.7)', // Active - Teal
                    'rgba(255, 99, 132, 0.7)'  // Inactive - Red
                ],
                borderColor: [
                    'rgba(75, 192, 192, 1)',
                    'rgba(255, 99, 132, 1)'
                ],
                borderWidth: 1
            }
        ]
    };

    const options = {
        responsive: true,
        cutout: '60%',
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 20,
                    padding: 15,
                },
            },
            datalabels: {
                color: '#000',
                formatter: (value, context) => {
                    const dataset = context.chart.data.datasets[0].data;
                    const total = dataset.reduce((acc, val) => acc + val, 0);
                    if (!total) return '0%';
                    const percentage = ((value / total) * 100).toFixed(1) + '%';
                    return percentage;
                },
                font: {
                    weight: 'bold',
                    size: 12
                }
            }
        }
    };

    return (
        <div className="card shadow-sm" style={{ maxWidth: '400px' }}>
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="card-title mb-0">Active Vehicles</h5>
                    <div style={{ position: 'relative' }}>
                        <i
                            className="fa-solid fa-filter d-none"
                            style={{ cursor: 'pointer', fontSize: '16px' }}
                            onClick={() => setShowDropdown(!showDropdown)}
                        ></i>
                        {showDropdown && (
                            <div
                                className="dropdown-menu show"
                                style={{ position: 'absolute', right: 0, zIndex: 999 }}
                            >
                                {filterOptions.map((range) => (
                                    <button
                                        key={range}
                                        className="dropdown-item"
                                        onClick={() => handleFilterSelect(range)}
                                    >
                                        {range}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div style={{ height: '280px', width: '280px', margin: 'auto' }}>
                    <Doughnut data={chartData} options={options} />
                </div>
            </div>
        </div>
    );
};

export default DashboardActiveVehicleTypeDetails;